import { Row, Col } from "react-bootstrap"
import NewsList from "@components/News/NewsList"
import React from "react"
import { SimplifiedNews } from "../../../types/news"
import Pagination from "@components/UI/Pagination"

export function NewsListPage({
  news,
  pageNum,
  pageCount,
  onNewsPaginationChange,
}: {
  news: SimplifiedNews[]
  pageNum: number
  pageCount: number
  onNewsPaginationChange: (page: number) => string
}) {
  return (
    <Row>
      <Col md={12}>
        <Row xl={3} lg={3} md={2} sm={12} xs={12}>
          <NewsList news={news} />
        </Row>
        <Row className={"page-desktop-row page-mobilegit-row"}>
          <Pagination page={pageNum} pageCount={pageCount} onChange={onNewsPaginationChange} />
        </Row>
      </Col>
    </Row>
  )
}
